// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"622a17d6","669":"e58b0a69","802":"0815f82c"}[chunkId] + ".chunk.js";
};